import React from 'react';
import PropTypes from 'prop-types';
import SoftBadge from 'components/common/SoftBadge';

// resolveLockSource names who blocked this driver, for the cases this feature
// can act on: a fraud rule, an admin, or both. Recovery clears any of them.
//
// A locked driver with neither flag was locked by something else - an operator
// setting the status by hand, or the inactive-driver cron. That is the plain
// status doing its job, so this feature says nothing about it.
export function resolveLockSource({ isVelocityLocked, isManuallyLocked }) {
  if (isVelocityLocked && isManuallyLocked) {
    return { label: 'Locked by fraud check and admin', bg: 'danger' };
  }

  if (isVelocityLocked) {
    return { label: 'Locked by fraud check', bg: 'danger' };
  }

  if (isManuallyLocked) {
    return { label: 'Locked by admin', bg: 'warning' };
  }

  return null;
}

// LockSourceBadge renders nothing for an unrestricted driver, and nothing for a
// lock this feature did not place.
export default function LockSourceBadge({ restrictions, className }) {
  if (!restrictions) return null;

  const source = resolveLockSource({
    isVelocityLocked: restrictions.is_velocity_locked,
    isManuallyLocked: restrictions.is_manually_locked
  });

  if (!source) return null;

  return (
    <SoftBadge bg={source.bg} className={className} pill>
      {source.label}
    </SoftBadge>
  );
}

LockSourceBadge.propTypes = {
  restrictions: PropTypes.shape({
    is_velocity_locked: PropTypes.bool,
    is_manually_locked: PropTypes.bool
  }),
  className: PropTypes.string
};
